import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const PAGE_TITLES = {
  '/':         'Dashboard',
  '/leads':    'Leads',
  '/pipeline': 'Pipeline',
  '/revenue':  'Revenue',
  '/kb':       'Knowledge Base',
  '/team':     'Team Performance',
  '/activity': 'Activity Logs',
  '/users':    'User Management',
};

export default function AppLayout({ children }) {
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] || 'Matply CRM';

  return (
    <div className="flex h-screen overflow-hidden bg-zinc-50">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar title={title} />
        <main className="flex-1 overflow-y-auto p-4">
          {children}
        </main>
      </div>
    </div>
  );
}
